/**
 * Type guard function that checks if a value is a bigint.
 * Returns true if the value is a bigint, false otherwise.
 *
 * @param value - The value to check
 * @returns True if the value is a bigint, false otherwise
 *
 * @example
 * ```ts
 * import { BigintQ } from "@pdfking/structs"
 *
 * BigintQ(10n) // true
 * BigintQ(10) // false
 * ```
 */
export const BigintQ = <T>(value: T): value is bigint & T => typeof value === "bigint"
